import Styles from "./styled";
import { useState } from "react";
import HiddenTab from "component/tab";
import ExpenseList from "./List";
import CreateExpense from "./Create";

export interface ITabData {
  activeKey: string;
  data?: {
    copiedId: number;
  };
}

interface IExpenseProps {
  isStaff: boolean
}

export default function Expense({ isStaff }: IExpenseProps) {
  const [tab, setTab] = useState<ITabData>({
    activeKey: "list",
  });
  const tabItems = [
    {
      key: "list",
      children: (
        <ExpenseList
          onChangeTab={setTab}
          isActive={tab.activeKey === "list"}
          isStaff={isStaff}
        />
      ),
    },
    {
      key: "create",
      children: (
        <CreateExpense
          onChangeTab={setTab}
          isActive={tab.activeKey === "create"}
          copiedId={tab.data?.copiedId}
        />
      ),
    },
  ];
  return (
    <Styles>
      <HiddenTab activeKey={tab.activeKey} onChange={setTab} items={tabItems} />
    </Styles>
  );
}
